/* eslint-disable @typescript-eslint/no-explicit-any */
import { CMSBlocks_PageView } from './cms-blocks-page-view';

import type { CMSPageType } from '../../domain/types/cms-page.types';


export const cmsPageViewsMap = {
  blocksPage: CMSBlocks_PageView
} as const satisfies Record<CMSPageType, (props: any) => JSX.Element>;
